import React, { useCallback } from 'react';
import { User } from '../../types';

interface GameMenuProps {
  user: User;
  onMenuClick: (page: 'main' | 'gta' | 'travel' | 'garage' | 'drugs' | 'crimes' | 'users-online' | 'jail' | 'blackjack' | 'roulette' | 'chase') => void;
}

const GameMenu = React.memo<GameMenuProps>(({ user, onMenuClick }) => {
  const handleLinkClick = useCallback((e: React.MouseEvent, page: 'main' | 'gta' | 'travel' | 'garage' | 'drugs' | 'crimes' | 'users-online' | 'jail' | 'blackjack' | 'roulette' | 'chase') => {
    e.preventDefault();
    onMenuClick(page);
  }, [onMenuClick]);

  const handleEscapeJail = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/game/release-jail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.ok) {
        // Refresh the page to update user data
        window.location.reload();
      }
    } catch (error) {
      console.error('Error escaping jail:', error);
    }
  }, []);

  return (
    <div className="game-menu">
      {/* Jail Escape Button */}
      {user.status === 'Jailed' && (
        <div className="jail-escape-section">
          <button 
            className="btn btn-danger btn-escape" 
            onClick={handleEscapeJail}
            title="Escape from jail (testing only)"
          >
            🚔 ESCAPE JAIL
          </button>
        </div>
      )}

      {/* Main Navigation */}
      <div className="menu-section">
        <div className="menu-section-title">Main</div>
        <div className="menu-links">
          <a href="#main" className="menu-link" onClick={(e) => handleLinkClick(e, 'main')}>
            🏠 Dashboard
          </a>
          <a href="#users-online" className="menu-link" onClick={(e) => handleLinkClick(e, 'users-online')}>
            👥 Users Online
          </a>
        </div>
      </div>

      {/* Ranking Section */}
      <div className="menu-section">
        <div className="menu-section-title">Ranking</div>
        <div className="menu-links">
          <a href="#crimes" className="menu-link" onClick={(e) => handleLinkClick(e, 'crimes')}>
            ⚔️ Crimes
          </a>
          <a href="#gta" className="menu-link" onClick={(e) => handleLinkClick(e, 'gta')}>
            🚗 Steal Cars
          </a>
          <a href="#chase" className="menu-link" onClick={(e) => handleLinkClick(e, 'chase')}>
            🚔 Chase
          </a>
                  <a href="#jail" className="menu-link" onClick={(e) => handleLinkClick(e, 'jail')}>
          🚔 Jail
        </a>
        <a href="#blackjack" className="menu-link" onClick={(e) => handleLinkClick(e, 'blackjack')}>
          🎰 Blackjack
        </a>
        <a href="#roulette" className="menu-link" onClick={(e) => handleLinkClick(e, 'roulette')}>
          🎲 Roulette
        </a>
        </div>
      </div>

      {/* GTA Section */}
      <div className="menu-section">
        <div className="menu-section-title">Grand Theft Auto</div>
        <div className="menu-links">
          <a href="#garage" className="menu-link" onClick={(e) => handleLinkClick(e, 'garage')}>
            🏢 Garage
          </a>
        </div>
      </div>

      {/* Travel Section */}
      <div className="menu-section">
        <div className="menu-section-title">Travel</div>
        <div className="menu-links">
          <a href="#travel" className="menu-link" onClick={(e) => handleLinkClick(e, 'travel')}>
            🗺️ Travel
          </a>
        </div>
      </div>

      {/* Drugs Section */}
      <div className="menu-section">
        <div className="menu-section-title">Business</div>
        <div className="menu-links">
          <a href="#drugs" className="menu-link" onClick={(e) => handleLinkClick(e, 'drugs')}>
            💊 Drugs
          </a>
          <a href="#weapons" className="menu-link">
            🔫 Weapons
          </a>
          <a href="#properties" className="menu-link">
            🏠 Properties
          </a>
        </div>
      </div>

      {/* Combat Section */}
      <div className="menu-section">
        <div className="menu-section-title">Combat</div>
        <div className="menu-links">
          <a href="#search" className="menu-link">
            🔍 Search Players
          </a>
          <a href="#hitlist" className="menu-link">
            🎯 Hitlist
          </a>
          <a href="#attacks" className="menu-link">
            ⚔️ Attacks
          </a>
        </div>
      </div>

      {/* Social Section */}
      <div className="menu-section">
        <div className="menu-section-title">Social</div>
        <div className="menu-links">
          <a href="#crews" className="menu-link">
            👥 Crews
          </a>
          <a href="#messages" className="menu-link">
            💬 Messages
          </a>
          <a href="#leaderboard" className="menu-link">
            🏆 Leaderboard
          </a>
        </div>
      </div>

      {/* Information Section */}
      <div className="menu-section">
        <div className="menu-section-title">Info</div>
        <div className="menu-links">
          <a href="#help" className="menu-link">
            ❓ Help
          </a>
          <a href="#rules" className="menu-link">
            📋 Rules
          </a>
          <a href="#about" className="menu-link">
            ℹ️ About
          </a>
        </div>
      </div>

      {/* Staff Tools Section (Mod/Admin) */}
      {user.rankId >= 20 && (
        <div className="menu-section">
          <div className="menu-section-title">Staff</div>
          <div className="menu-links">
            <a href="#admin" className="menu-link">
              ⚙️ Admin Panel
            </a>
            <a href="#mod-tools" className="menu-link">
              🛠️ Mod Tools
            </a>
          </div>
        </div>
      )}
    </div>
  );
});

export default GameMenu;
